import { useState } from 'react';
import '@/styles/landing-v2.css';
import Header from '@/components/landing-v2/Header';
import Hero from '@/components/landing-v2/Hero';
import IntegrationStrip from '@/components/landing-v2/IntegrationStrip';
import Features from '@/components/landing-v2/Features';
import Atlas from '@/components/landing-v2/Atlas';
import { TwoSides, Scenarios, Compounding } from '@/components/landing-v2/MidSections';
import FAQ from '@/components/landing-v2/FAQ';
import CTA from '@/components/landing-v2/CTA';
import FooterV2 from '@/components/landing-v2/FooterV2';
import { useScrollReveal, scrollToAnchor } from '@/components/landing-v2/useScrollReveal';
import { LanguageProvider } from '@/i18n/LanguageContext';

function HomeContent() {
  const [ctaPane, setCtaPane] = useState<'request' | 'invite'>('request');

  useScrollReveal();

  const jumpToCta = (pane: 'request' | 'invite') => {
    setCtaPane(pane);
    scrollToAnchor('#cta');
  };

  return (
    <div className="landing-v2" id="top">
      <Header onCtaJump={jumpToCta} />
      <main>
        <Hero
          onRequestAccess={() => jumpToCta('request')}
          onWatchDemo={() =>
            window.open('https://www.youtube.com/shorts/Hqn1n3BD-P8', '_blank', 'noopener')
          }
        />
        <IntegrationStrip />
        <Features />
        <Atlas />
        <TwoSides />
        <Scenarios />
        <Compounding />
        <FAQ onTalkToUs={() => jumpToCta('request')} />
        <CTA pane={ctaPane} setPane={setCtaPane} />
      </main>
      <FooterV2 />
    </div>
  );
}

export default function Home() {
  return (
    <LanguageProvider>
      <HomeContent />
    </LanguageProvider>
  );
}
